export default {
    MOVIE: 'MOVIE',
    BOOK: 'BOOK',
    ROUTINE: 'ROUTINE',
    DYNAMIC: 'DYNAMIC',
    QUESTION: 'QUESTION',
};

export const translatedDigestCategories = {
    MOVIE: 'Filme',
    BOOK: 'Livro',
    ROUTINE: 'Rotina',
    DYNAMIC: 'Dinâmico',
    QUESTION: 'Pergunta',
};



// WEBPACK FOOTER //
// ./src/utils/digest-categories.js